<template>
  <div class="onboarding-static-page-container">
      <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions" :menus="menuOptions"></OnboardingMenu>
      <div class="header">
        <p>{{ $t('onboarding.nestle.myFirstDayPageTW.title') }}</p>
      </div>
      <div class="body">
        <div class="text-board clear-margin-top">
          <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageTW.tw') }}</p>
          <p class="board-subtitle">{{ $t('onboarding.nestle.myFirstDayPageTW.information') }}</p>
        </div>
        <div class="image-board clear-margin-top" @click="toOutSide('https://www.nestle.com.tw')">
            <img :src="firstImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageTW.twWebSite') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="image-board flex-derection-row-reverse" @click="toOutSide('https://www.nestle.com.tw/aboutus/nestlestory')">
            <img :src="secondImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageTW.story') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="image-board" @click="toOutSide('https://www.google.com.tw/maps/place/114%E5%8F%B0%E5%8C%97%E5%B8%82%E5%85%A7%E6%B9%96%E5%8D%80%E7%91%9E%E5%85%89%E8%B7%AF399%E8%99%9F/@25.0776906,121.5703217,17z/data=!4m13!1m7!3m6!1s0x3442ac654af0a76b:0x6f0f26fa34aa7a2b!2zMTE05Y-w5YyX5biC5YWn5rmW5Y2A55Ge5YWJ6LevMzk56Jmf!3b1!8m2!3d25.0776906!4d121.5725157!3m4!1s0x3442ac654af0a76b:0x6f0f26fa34aa7a2b!8m2!3d25.0776906!4d121.5725157?hl=zh-TW')">
            <img :src="thirdImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageTW.twOffice') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="image-board flex-derection-row-reverse" @click="toOutSide('https://www.youtube.com/user/NestleInTW')">
            <img :src="fifthImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageTW.twYoutube') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="image-board" @click="toOutSide('https://www.facebook.com/NestleTW/?ref=bookmarks')">
            <img :src="sixthImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageTW.twFacebook') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="follow">
          <p v-html="$t('onboarding.nestle.followUs')"></p>
          <p>{{ $t('onboarding.nestle.donnotBeShared') }}</p>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import Footer from '@/components/onboarding/form/Footer'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, Footer
  },
  data () {
    const isMobile = deviceType.isMobile
    return {
      firstImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/tw/website.jpg' : '@/assets/image/onboarding/my-first-day/pc/tw/website.jpg'),
      secondImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/tw/story.jpg' : '@/assets/image/onboarding/my-first-day/pc/tw/story.jpg'),
      thirdImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/tw/office.jpg' : '@/assets/image/onboarding/my-first-day/pc/tw/office.jpg'),
      fourthImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/tw/linkedIn.jpg' : '@/assets/image/onboarding/my-first-day/pc/tw/linkedIn.jpg'),
      fifthImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/tw/youTube.jpg' : '@/assets/image/onboarding/my-first-day/pc/tw/youTube.jpg'),
      sixthImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/tw/facebook.jpg' : '@/assets/image/onboarding/my-first-day/pc/tw/facebook.jpg')
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/onboarding-static-page.scss';

.onboarding-static-page-container {
  .header {
    background-image: url('~@/assets/image/onboarding/my-first-day/h5/banner.jpg');
  }
}

/* 中型设备（台式电脑） */
@media (min-width: 769px) {
  .onboarding-static-page-container {
    .header {
      background-image: url('~@/assets/image/onboarding/my-first-day/pc/banner.jpg');
    }
  }
}
</style>
